import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import TeamDetailsMain from "./TeamDetailsMain";
import Footer from "../../components/Footer";

const TeamDetails = () => {
  return (
    <>
      <HeaderFour />

      <TeamDetailsMain />

      <Footer />
    </>
  );
};

export default TeamDetails;
